//球队管理
import { MessageBox, Message } from 'element-ui'
import store from '@/store'

import request from '@/utils/request'
/* 队伍详情
@params
data 
{
    "uid": 245945
}
@return 
{
    "code": "0",
    "method": "team.detail",
    "o_ret": {
        "team": {//队伍信息
            "area": "宁波",//地区
            "name": "它山堰社区",//队名
            "id": 43,//队伍id
            "substitute": 0,//是否替补0-正常  1-替补
            "status": 4 //状态0-新建 1-等待队员 2-待提交审核 3-已提交审核 4-审核通过 5-审核未通过

        },
        "list": [//队员列表
            {
                "age": 37,//年龄
                "capital": 0,//是否队长  1 是，0 否
                "couch": 0,//是否教练   1是，0 否
                "createdate": 1595822525000,//添加时间
                "dataStatus": 0, //0 邀请中，1 接受邀请
                "headerimg": "https://tiqiuqu-api.gtdreamlife.com/image/2020/07/30/aa4c5ca9-7589-430c-b910-aedbaa85fb28.jpg",// 头像
                "height": 165,//身高
                "id": 269,//id
                "idno": "330227198405215418",//身份证号
                "idpicts": "https://tiqiuqu-api.gtdreamlife.com/image/2020/07/27/39636d48-d23d-4cc4-99d6-aeed1db65551.jpg,https://tiqiuqu-api.gtdreamlife.com/image/2020/07/27/78cb5b16-b7e3-4711-9540-0c307b1505a9.jpg",//身份证照片地址
                "idtype": 0,//证件类别1-身份证 2-护照
                "inviteId": 269,//邀请id
                "isnew": 0,
                "leader": 0,//是否领队0-否 1-是
                "member": 1,//是否普通队员0-否 1-是
                "name": "葛春杰",
                "phone": "13221427165",
                "shirtnumber": 1,//球衣号码
                "shirtsize": "XXL",//球衣尺寸
                "smssent": 1,//1：短信已发
                "status": 1,//0 新建，1 资料已填
                "substitute": 0,//是否替补队员0-否 1-是
                "teamid": 43,
                "uid": 18918,//球员id
                "upatetimes": 1,//更新数
"updatedate": 1596169816000,//跟新时间
                "weight": 72//体重
            }
        ]
    "message": "success"
}
*/
export function teamDetail(data) {
    return request({
        method: 'post',
        data: {
            method: "team.detail",
            data: data
        }
    })
}
/* 队员详情
@params
data
{
    "inviteId": "3039"
}
@return
{
   "code": "0",
	"method": "team.memdetail",
	"o_ret": {
		"isagree": 0,
		"member": {
			"age": 21,
			"capital": 0,
			"couch": 0,
			"createdate": 1620616886000,
			"dataStatus": 0,
			"headerimg": "https://activity-tqquat.gtdreamlife.com/image/2021/05/10/d74f7037-5638-40b7-9014-cee23a3fd6c9.jpg",
			"height": 178,
			"id": 3039,
			"idno": "342427199303451619",
			"idpicts": "https://activity-tqquat.gtdreamlife.com/image/2021/05/10/801ee68e-9e97-4437-8e21-1374b5924ee0.jpg,https://activity-tqquat.gtdreamlife.com/image/2021/05/10/6308234e-bd7f-4c04-a7c2-07e07ad1aa84.jpg",
			"idtype": 0,
			"inviteId": 0,
			"isnew": 0,
			"leader": 1,
			"member": 1,
			"name": "俞凯",
			"phone": "13053273506",
			"shirtnumber": 3,
			"shirtsize": "XL",
			"smssent": 0,
			"status": 0,
			"substitute": 0,
			"teamid": 306,
			"uid": 245945,
			"upatetimes": 1,
			"updatedate": 1620629367000,
			"weight": 60
		},
		"team": {
			"name": "神龙1",
			"id": 306,
			"status": 1
		}
	}
	"message": "success"
}
*/
export function memberDetail(data) {
	
    return request({
        method: 'post',
        data: {
            method: "team.memdetail",
            data: data
        }
    })
}

/* 编辑队员
@params
data
{
       "uid": "245945",
		"teamid": 306,
		"member": {
			"idpict1": "https://activity-tqquat.gtdreamlife.com/image/2021/05/10/801ee68e-9e97-4437-8e21-1374b5924ee0.jpg",
			"idpict2": "https://activity-tqquat.gtdreamlife.com/image/2021/05/10/6308234e-bd7f-4c04-a7c2-07e07ad1aa84.jpg",
			"weight": "60",
			"shirtnumber": 3,
			"idno": "342427199303451619",
			"shirtsize": "XL",
			"phone": "13053273506",
			"name": "俞凯",
			"member": 1,
			"id": "3039",
			"age": "21",
			"height": "178",
			"headerimg": "https://activity-tqquat.gtdreamlife",
			"status": "1" //0 邀请中，1 加入队伍，2 填写中
			"age": "20",
			"member": "0" //是否普通球员 0 否 1 是
		}
}
@return
{
   "code": "0",
	"method": "team.setSomeone",
	"message": "success"
}
*/
export function editMember(data) {
	if (store.getters.teamStatus == 4 || store.getters.teamStatus == 3) {
		Message({
			message: '队伍已提交审核,无法再修改',
			type: 'error',
		})
		return { code: '301', message: '队伍已提交审核，无法再修改' }
	}
    return request({
        method: 'post',
        data: {
            method: "team.setSomeone",
            data: data
        }
    })
}
/* 

	"data": {
		"uid": 245945,
		"leader": {
			"area": "杭州",
			"phone": "13053273501",
			"teamid": 0,
			"name": "张三",
			"idno": "342427199303450000",
			"leaderid": 0,
			"teamname": "神龙1",
			"headerimg": "https://tiqiuqu-api.gtdreamlife.com/image/2021/05/10/f4e9c4f6-9958-4041-bd12-5384634829ab.jpg"
		}
	},
	"header": {
		"uid": 0,
		"guid": "0000",
		"chnl": "0000",
		"platform": "H5",
		"versionCode": "10000"
	}
}

返回值：
{
	"code": "0",
	"method": "team.saveLeader",
	"o_ret": {
		"code": "970439",//队伍编码
		"teamid": 306,//队伍id
		"leadercode": "479862",//领队编码
		"leaderid": 3039 //领队id
	},
	"message": "success"
}
*/
export function saveTeamLeader(data) {

	return request({
		method: 'post',
		data: {
			method: "team.saveLeader",
			data: data,
			"header": {
				"uid": 0,
				"guid": "0000",
				"chnl": "0000",
				"platform": "H5",
				"versionCode": "10000"
			}
		}
	})
}
/* 
	1.10  获取邀请列表
参数：
{
    "method": "team.getInviteList",
    "data": {
        "phone": "12312312344"
    }
}
*/
export function invited(phoneNo) {

	return request({
		method: 'post',
		data: {
			method: "team.getInviteList",
			data: { phone: phoneNo}
		}
	})
}

/* 
	参数
	"teamid": 306,
		"members": [{
			"phone": "13675880758",//手机号
			"name": "张三",
			"shirtnumber": "1" //球服号码
		}]
*/
export function saveMem(params) {
	if (!store.getters.team) {
		Message({
			message: '已丢失队伍信息',
			type: 'error',
		})
		return {code:'301',message:'已丢失队伍信息'}
	}
	if (store.getters.teamStatus == 4 || store.getters.teamStatus == 3) {
		Message({
			message: '队伍已提交审核无法再邀请球员',
			type: 'error',
		})
		return {code:'301',message:'队伍已提交审核无法再邀请球员'}
	}
	return request({
		method: 'post',
		data: {
			method: "team.saveMem",
			data: params
		}
	})
}
/* {
	"method": "team.toAudit",
		"data": {
		"teamid": "304"
	}
} */
export function toAudit(teamid){
	if (!store.getters.team) {
		Message({
			message: '已丢失队伍信息',
			type: 'error',
		})
		return {code:'301',message:'已丢失队伍信息'}
	}
	if (store.getters.teamStatus == 4 || store.getters.teamStatus == 3) {
		Message({
			message: '队伍已提交审核,请勿重复提交',
			type: 'error',
		})
		return {code:'301',message:'队伍已提交审核'}
	}
	return request({
		method: 'post',
		data: {
			method: "team.toAudit",
			data: { teamid: teamid }
		}
	})
}
export function saveCapitalAndCouch(params) {
	if (!store.getters.team) {
		Message({
			message: '已丢失队伍信息',
			type: 'error',
		})
		return {code:'301',message:'已丢失队伍信息'}
	}
	if (store.getters.teamStatus == 4 || store.getters.teamStatus == 3) {
		Message({
			message: '队伍已提交审核无法修改',
			type: 'error',
		})
		return {code:'301',message:'队伍已提交审核无法修改'}
	}
	return request({
		method: 'post',
		data: {
			method: "team.saveCapitalAndCouch",
			data: params
		}
	})
}


// WEBPACK FOOTER //
// ./src/api/team.js